/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorDocumentControllerCreate } from '../fn/vendor-document/vendor-document-controller-create';
import { VendorDocumentControllerCreate$Params } from '../fn/vendor-document/vendor-document-controller-create';
import { vendorDocumentControllerDelete } from '../fn/vendor-document/vendor-document-controller-delete';
import { VendorDocumentControllerDelete$Params } from '../fn/vendor-document/vendor-document-controller-delete';
import { vendorDocumentControllerFindAll } from '../fn/vendor-document/vendor-document-controller-find-all';
import { VendorDocumentControllerFindAll$Params } from '../fn/vendor-document/vendor-document-controller-find-all';
import { vendorDocumentControllerFindAllByClientId } from '../fn/vendor-document/vendor-document-controller-find-all-by-client-id';
import { VendorDocumentControllerFindAllByClientId$Params } from '../fn/vendor-document/vendor-document-controller-find-all-by-client-id';
import { vendorDocumentControllerFindById } from '../fn/vendor-document/vendor-document-controller-find-by-id';
import { VendorDocumentControllerFindById$Params } from '../fn/vendor-document/vendor-document-controller-find-by-id';
import { vendorDocumentControllerSearchCursor } from '../fn/vendor-document/vendor-document-controller-search-cursor';
import { VendorDocumentControllerSearchCursor$Params } from '../fn/vendor-document/vendor-document-controller-search-cursor';
import { vendorDocumentControllerSearchOffset } from '../fn/vendor-document/vendor-document-controller-search-offset';
import { VendorDocumentControllerSearchOffset$Params } from '../fn/vendor-document/vendor-document-controller-search-offset';
import { vendorDocumentControllerUpdate } from '../fn/vendor-document/vendor-document-controller-update';
import { VendorDocumentControllerUpdate$Params } from '../fn/vendor-document/vendor-document-controller-update';
import { VendorDocumentDto } from '../models/vendor-document-dto';

@Injectable({ providedIn: 'root' })
export class VendorDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorDocumentControllerFindAll()` */
  static readonly VendorDocumentControllerFindAllPath = '/api/vendorDocument';

  /**
   * 문서 전체 조회.
   *
   * 문서 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindAll$Response(params?: VendorDocumentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorDocumentDto>>> {
    return vendorDocumentControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 전체 조회.
   *
   * 문서 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindAll(params?: VendorDocumentControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorDocumentDto>> {
    return this.vendorDocumentControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorDocumentDto>>): Array<VendorDocumentDto> => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerCreate()` */
  static readonly VendorDocumentControllerCreatePath = '/api/vendorDocument';

  /**
   * 입점사 - 고객사 문서 생성.
   *
   * 입점사 - 고객사 문서를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorDocumentControllerCreate$Response(params: VendorDocumentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
    return vendorDocumentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 - 고객사 문서 생성.
   *
   * 입점사 - 고객사 문서를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorDocumentControllerCreate(params: VendorDocumentControllerCreate$Params, context?: HttpContext): Observable<VendorDocumentDto> {
    return this.vendorDocumentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorDocumentDto>): VendorDocumentDto => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerFindAllByClientId()` */
  static readonly VendorDocumentControllerFindAllByClientIdPath = '/api/vendorDocument/all/{clientWorkspaceId}';

  /**
   * 고객사 ID 기반 문서 전체 조회.
   *
   * 고객사 ID로 문서 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerFindAllByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindAllByClientId$Response(params: VendorDocumentControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorDocumentDto>>> {
    return vendorDocumentControllerFindAllByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID 기반 문서 전체 조회.
   *
   * 고객사 ID로 문서 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerFindAllByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindAllByClientId(params: VendorDocumentControllerFindAllByClientId$Params, context?: HttpContext): Observable<Array<VendorDocumentDto>> {
    return this.vendorDocumentControllerFindAllByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorDocumentDto>>): Array<VendorDocumentDto> => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerSearchOffset()` */
  static readonly VendorDocumentControllerSearchOffsetPath = '/api/vendorDocument/search/offset';

  /**
   * 문서 오프셋 기반 조회.
   *
   * 문서를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerSearchOffset$Response(params: VendorDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorDocumentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 오프셋 기반 조회.
   *
   * 문서를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerSearchOffset(params: VendorDocumentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorDocumentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerSearchCursor()` */
  static readonly VendorDocumentControllerSearchCursorPath = '/api/vendorDocument/search/cursor';

  /**
   * 문서 커서 기반 조회.
   *
   * 문서를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerSearchCursor$Response(params: VendorDocumentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorDocumentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 커서 기반 조회.
   *
   * 문서를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerSearchCursor(params: VendorDocumentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorDocumentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerFindById()` */
  static readonly VendorDocumentControllerFindByIdPath = '/api/vendorDocument/{id}';

  /**
   * 문서 ID 기반 조회.
   *
   * 문서를 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindById$Response(params: VendorDocumentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
    return vendorDocumentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 ID 기반 조회.
   *
   * 문서를 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerFindById(params: VendorDocumentControllerFindById$Params, context?: HttpContext): Observable<VendorDocumentDto> {
    return this.vendorDocumentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorDocumentDto>): VendorDocumentDto => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerDelete()` */
  static readonly VendorDocumentControllerDeletePath = '/api/vendorDocument/{id}';

  /**
   * 문서 삭제.
   *
   * 문서를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerDelete$Response(params: VendorDocumentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
    return vendorDocumentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 삭제.
   *
   * 문서를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorDocumentControllerDelete(params: VendorDocumentControllerDelete$Params, context?: HttpContext): Observable<VendorDocumentDto> {
    return this.vendorDocumentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorDocumentDto>): VendorDocumentDto => r.body)
    );
  }

  /** Path part for operation `vendorDocumentControllerUpdate()` */
  static readonly VendorDocumentControllerUpdatePath = '/api/vendorDocument/{id}';

  /**
   * 문서 수정.
   *
   * 문서를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorDocumentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorDocumentControllerUpdate$Response(params: VendorDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
    return vendorDocumentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 문서 수정.
   *
   * 문서를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorDocumentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorDocumentControllerUpdate(params: VendorDocumentControllerUpdate$Params, context?: HttpContext): Observable<VendorDocumentDto> {
    return this.vendorDocumentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorDocumentDto>): VendorDocumentDto => r.body)
    );
  }

}
